import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export const RedirectToPublicSubmission = () => {
  const { submissionId, accountId, matchesId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(
      `/account/${accountId}/submission/${submissionId}/engagement${matchesId ? `/${matchesId}` : ''}`,
      { replace: true }
    );
  }, [navigate, submissionId, accountId, matchesId]);

  return null;
};
